export default {
  sport: {
    en: 'All {sportName} events',
  },
}
